import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
const REAL_PHOTOS = [{
  src: 'https://cdn.magicpatterns.com/uploads/33vHLTnabL2uWLAhXboGLX/WhatsApp_Image_2026-05-11_at_12.47.39_PM.jpg',
  alt: 'Reader holding the Pleasure, Guilt and Emptiness collection'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2duFZvKRHuDgQCEyYS5XDK/ChatGPT_Image_21_may_2026,_17_32_32.png',
  alt: 'Reader showing the book on a tablet'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/n5SmhhXUy7yTLa4qJ7ssum/ChatGPT_Image_21_may_2026,_17_21_20.png',
  alt: 'Reader with the printed book'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/srchCqeYXqiXcrdQHvuR21/ChatGPT_Image_21_may_2026,_17_00_38.png',
  alt: 'Reader in the park with the book'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6UAhpKA3BGsiDx5nNqfcnM/ChatGPT_Image_21_may_2026,_16_26_25.png',
  alt: 'Reader holding the book in bed'
}];
export function PainSection() {
  const painPoints = [{
    icon: '🔄',
    text: 'You slipped again into what you promised you would not do — and the worst part was not the act, but the guilt that came after.'
  }, {
    icon: '😶',
    text: 'You are functional, you "have it all under control" — but something pulls in another direction that you cannot explain to anyone.'
  }, {
    icon: '💪',
    text: 'You tried willpower, apps, books, promises to yourself. It worked for a while. The cycle came back.'
  }, {
    icon: '🪤',
    text: 'It feels like the longer you have been in this, the harder it gets to believe anything can be different.'
  }, {
    icon: '😔',
    text: 'The guilt you feel afterwards does not protect you from the next relapse. It sets you up for it.'
  }];
  const [photoIdx, setPhotoIdx] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setPhotoIdx(i => (i + 1) % REAL_PHOTOS.length);
    }, 3500);
    return () => clearInterval(id);
  }, []);
  return <section className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_top_right,rgba(194,0,111,0.15)_0%,transparent_60%),var(--dark-bg)]" data-id="element-147" data-mp="p3k23xinejye">
      <div className="max-w-[900px] mx-auto" data-id="element-148" data-mp="ytvk2nz62toa">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-149" data-mp="yu58i74kcsrv">
          Does this sound like you?
        </span>
        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-150" data-mp="65zmzi5oqzqz">
          How many times did you say
          <br data-id="element-151" data-mp="b6596it6ru1o" />
          <span className="text-gradient-magenta" data-id="element-152" data-mp="f5mdva0sgn5s">"never again"</span> —<br data-id="element-153" data-mp="f42z5nus6k64" />
          and fall right back in?
        </h2>
        <ul className="list-none mt-3 mb-3 space-y-2" data-id="element-154" data-mp="k58ttr804hia">
          {painPoints.map((point, idx) => <li key={idx} className="flex items-start gap-3 py-3 px-4 bg-[rgba(194,0,111,0.08)] border border-[rgba(194,0,111,0.2)] border-l-4 border-l-magenta rounded-[10px] text-[0.95rem] leading-[1.5] text-white/85 transition-[transform,background-color,border-color] duration-300 hover:bg-[rgba(194,0,111,0.15)] hover:border-l-magenta-bright hover:translate-x-[5px]" data-id="element-155" data-mp="1qlktjwqh27fz" data-mpi={idx}>
              <span className="text-[1.4rem] shrink-0 mt-[2px]" data-id="element-156" data-mp="1vwyd4a7si0zw">
                {point.icon}
              </span>
              <span data-id="element-157" data-mp="1rvwn8jzrj1al">{point.text}</span>
            </li>)}
        </ul>
        <div className="bg-gradient-to-br from-[rgba(107,0,182,0.3)] to-[rgba(194,0,111,0.2)] border border-[rgba(194,0,111,0.4)] rounded-2xl py-4 px-5 mt-3 text-center" data-id="element-158" data-mp="1mycwwlpsiy2a">
          <blockquote className="font-heading font-bold text-[clamp(1rem,2.5vw,1.35rem)] leading-[1.45] text-white" data-id="element-159" data-mp="1cyvrm5egam6u">
            "The cycle does not persist because you are weak.
            <br data-id="element-160" data-mp="18zwsx2jbblnu" />
            It persists because{' '}
            <em className="text-magenta-bright not-italic" data-id="element-161" data-mp="37bvfelszimp7">
              nobody ever gave you the tools to interrupt it.
            </em>
            "
          </blockquote>
        </div>
        {/* Real People Carousel — Social proof */}
        <div className="mt-6" data-id="element-162" data-mp="3acyl6ilqnsap">
          <h3 className="font-heading font-bold text-[0.9rem] tracking-[2px] uppercase text-white/50 mb-3 text-center" data-id="element-163" data-mp="3fee4a54cvoqg">
            Real people with the book
          </h3>
          <div className="relative max-w-[320px] mx-auto" data-id="element-164" data-mp="31gfw5hgmooje">
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden border border-magenta/30 shadow-[0_15px_50px_rgba(194,0,111,0.35),0_0_30px_rgba(107,0,182,0.25)] bg-card-bg" data-id="element-165" data-mp="35e3rglm8gjbt">
              <AnimatePresence mode="wait" data-id="element-166" data-mp="2wfs4ctkks3o4">
                <motion.img key={photoIdx} src={REAL_PHOTOS[photoIdx].src} alt={REAL_PHOTOS[photoIdx].alt} initial={{
                opacity: 0,
                scale: 1.03
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 0.98
              }} transition={{
                duration: 0.3,
                ease: [0.23, 1, 0.32, 1]
              }} className="absolute inset-0 w-full h-full object-cover" data-id="element-167" data-mp="2wgtij6ww16a2" />
              </AnimatePresence>
              {/* Subtle gradient overlay for depth */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" data-id="element-168" data-mp="2d1bdwg399ir2" />
              {/* Verified badge */}
              <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-black/60 backdrop-blur-sm border border-white/10 rounded-full py-1 px-2.5" data-id="element-169" data-mp="280dxa7xw8wro">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400" data-id="element-170" data-mp="2htcmns17srcc" />
                <span className="text-[0.65rem] text-white/85 font-heading font-bold tracking-wide uppercase" data-id="element-171" data-mp="2vrjbyjs3lj0e">
                  Real photo
                </span>
              </div>
            </div>
            {/* Progress dots */}
            <div className="flex items-center justify-center gap-2 mt-4" data-id="element-172" data-mp="1oguzro31nkme">
              {REAL_PHOTOS.map((_, idx) => <button key={idx} type="button" onClick={() => setPhotoIdx(idx)} aria-label={`View photo ${idx + 1}`} className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${idx === photoIdx ? 'w-6 bg-magenta-bright' : 'w-1.5 bg-white/25 hover:bg-white/45'}`} data-id="element-173" data-mp="1tewn4l7i663o" data-mpi={idx} />)}
            </div>
          </div>
        </div>
        {/* Customer Reviews */}
        <div className="mt-6" data-id="element-174" data-mp="2h4qvapgvn6hl">
          <h3 className="font-heading font-bold text-[0.9rem] tracking-[2px] uppercase text-white/50 mb-3 text-center" data-id="element-175" data-mp="2l5ub5byxd2it">
            What readers are saying
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-176" data-mp="ms1269yc21b9">
            {/* Review 1 */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-[border-color] duration-300 hover:border-magenta/30 flex flex-col" data-id="element-177" data-mp="qsbf66kjlrzm">
              <div className="flex items-center gap-2 mb-2" data-id="element-178" data-mp="ehbr5v62gjdc">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-179" data-mp="9ih0y85rrsj7">
                  ★★★★★
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-180" data-mp="5hou1lkddzq3">
                "I read it in one night. For the first time I understood why
                what was happening to me was happening. I cried, but out of
                relief."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60 mt-auto" data-id="element-181" data-mp="t680rwnru4g2">
                — Camila R.
              </p>
            </div>
            {/* Review 2 */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-[border-color] duration-300 hover:border-magenta/30 flex flex-col" data-id="element-182" data-mp="o9pv8ukma22o">
              <div className="flex items-center gap-2 mb-2" data-id="element-183" data-mp="38w1a2604pqr3">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-184" data-mp="1cty31lfxd9bg">
                  ★★★★<span className="text-white/20" data-id="element-185" data-mp="1gw2ymppxog0q">★</span>
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-186" data-mp="12wa048860vi7">
                "I thought it was another generic self-help book. I was wrong.
                It is direct, no fluff, and it works."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60 mt-auto" data-id="element-187" data-mp="1vkpbmks38vos">
                — Martin L.
              </p>
            </div>
            {/* Review 3 */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-[border-color] duration-300 hover:border-magenta/30 flex flex-col" data-id="element-188" data-mp="1lvnwsxxa4kce">
              <div className="flex items-center gap-2 mb-2" data-id="element-189" data-mp="1qs615wop6go7">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-190" data-mp="2ej1l67mww7kw">
                  ★★★★★
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-191" data-mp="2jcmjk0sf33km">
                "I have been applying the method for 3 weeks and the difference
                is real. I wish I had found it sooner."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60 mt-auto" data-id="element-192" data-mp="goeb0c64e31e">
                — Diego M.
              </p>
            </div>
            {/* Review 4 */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-[border-color] duration-300 hover:border-magenta/30 flex flex-col" data-id="element-193" data-mp="3l231e297p00k">
              <div className="flex items-center gap-2 mb-2" data-id="element-194" data-mp="3g4ughtwoihvm">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-195" data-mp="3u3148h7wz1hk">
                  ★★★★<span className="text-white/20" data-id="element-196" data-mp="3p3y0d03o71b6">★</span>
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-197" data-mp="19ca476whdctf">
                "It gave me concrete tools, not empty phrases. I recommend it to
                anyone who feels they cannot do this alone."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60 mt-auto" data-id="element-198" data-mp="hvm67rzslqft">
                — Valentina S.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}